import { create } from "zustand"
import { persist } from "zustand/middleware"

interface GroupState {
  activeGroupId: string | null
  setActiveGroupId: (groupId: string | null) => void
}

export const useActiveGroup = create<GroupState>()(
  persist(
    (set) => ({
      activeGroupId: null,
      setActiveGroupId: (groupId) => set({ activeGroupId: groupId }),
    }),
    {
      name: "active-group-storage",
    }
  )
)